/** Base Url */
export const REDIRECT_BASE =
  import.meta.env.VITE_APP_REDIRECT_BASE || "http://localhost:3000/";
export const BaseUrl = import.meta.env.VITE_APP_BASEURL;

/** User Api */
const ENVIRONMENT: string = import.meta.env.VITE_APP_ENVIRONMENT || "dev"; // Get the environment from .env file

const getRedirectURL = () => {
  if (ENVIRONMENT === "local") return "http://localhost:3000/";
  else return REDIRECT_BASE;
};

//dev
// export const REDIRECT_BASE =
//   "https://fauna-protect-pwa-dev.thoughtlinetech.net/";
//uat
// export const REDIRECT_BASE = "https://fauna-protect-pwa.thoughtlinetech.net/";
// export const BaseUrl = "https://faunaprotect.thoughtlinetech.net/api";

//test
//export const REDIRECT_BASE = "https://fauna-protect-pwa.thoughtlinetech.net/";
// export const BaseUrl = "https://portal-test.faunaprotect.nl/api";

//prod
//export const REDIRECT_BASE = "https://portal.faunaprotect.nl/";
// export const BaseUrl = 'https://portal.faunaprotect.nl/api';
/**User Api */

// const ENVIRONMENT: string = "dev"; // Assign one of the allowed values
// const getRedirectURL = () => {
//   if (ENVIRONMENT === "local") return "http://localhost:3000/";
//   else return REDIRECT_BASE;
// };

export const LoginApi = BaseUrl + "/login";

export const LogoutApi = BaseUrl + "/logout";

export const ForgotPasswordApi = BaseUrl + "/reset/password";

export const RequestResetPassword = BaseUrl + "/reset-password";

export const REDIRECT_URL_RESET_PASSWORD = getRedirectURL();

export const TaskDetailsApi = BaseUrl + "/tasks_details_api";

export const TaskListingApi = BaseUrl + "/tasks_listing_api";

export const ProjectListingApi = BaseUrl + "/projects_listing_api";

export const ActivateFlag = BaseUrl + "/activate_flag";

export const MaterialCheck = BaseUrl + "/update_material_completion";

export const MaterialUpdate = BaseUrl + "/task_update_api";

export const WorkerRemarkUpdate = BaseUrl + "/save_worker_remarks_for_task";

export const PMRemarkStatusUpdate = BaseUrl + "/update_pm_remarks_status";

export const PlanningOverView = BaseUrl + "/PlanningWorkersListing";

export const FetchWorkerHoursLogging = BaseUrl + "/fetchWorkerLogs";

export const SaveWorkerHoursLogging = BaseUrl + "/saveWorkerLogs";

export const MaterialWiseTaskListingDropDown =
  BaseUrl + "/showSameMaterialtasks";

export const PhotoUpdateForSameProjectTaskMaterial =
  BaseUrl + "/updateBulkTask";

export const VgmPdfGeneratorApi = BaseUrl + "/makeVGM";

export const GetSafetyInstructionApi = BaseUrl + "/getToonInstruction";

export const GetWorkerTimerRunningStatus = BaseUrl + "/isWorkerTimerRunning";

export const LogOutApi = BaseUrl + "/logUserActivityFromPwa";

export interface AxiosResponse {
  data: any;
  status: boolean;
  status_code: number;
  status_message: string;
  errors?: any;
}
